// extracted by mini-css-extract-plugin
export default {"lineaButton":"LineaButton_lineaButton__vEz17"};